import { useEffect, useRef, useState } from 'react'

export function usePreviewSelection(initialIndex = 0) {
  const [selectedIndex, setSelectedIndex] = useState<number | null>(null)
  const [activeIndex, setActiveIndex] = useState(initialIndex)
  const scopeRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    if (selectedIndex === null) return

    const unlockOutside = (event: PointerEvent) => {
      const target = event.target as Node | null
      if (target && scopeRef.current && !scopeRef.current.contains(target)) {
        setSelectedIndex(null)
      }
    }

    document.addEventListener('pointerdown', unlockOutside)
    return () => document.removeEventListener('pointerdown', unlockOutside)
  }, [selectedIndex])

  return {
    scopeRef,
    selectedIndex,
    activeIndex,
    isLocked: selectedIndex !== null,
    preview: (index: number) => {
      if (selectedIndex === null) setActiveIndex(index)
    },
    commit: (index: number) => {
      setSelectedIndex(index)
      setActiveIndex(index)
    },
    unlock: () => setSelectedIndex(null),
  }
}
